import { Alert, Link, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useDuplicates } from '../api/hooks';
import { describeError } from '../components/Notify';
import { DuplicateActions, DuplicateScore, DuplicateSignals } from '../drawer/DuplicatesSection';
import { useCycleParam, useUrlState } from '../urlState';

export function DuplicatesTab() {
  const dups = useDuplicates(useCycleParam());
  const { set } = useUrlState();
  return (
    <>
      {dups.error && <Alert severity="error">{describeError(dups.error)}</Alert>}
      <TableContainer component={Paper}>
        <Table size="small" aria-label="Possible duplicates">
          <TableHead>
            <TableRow>
              <TableCell>Household (kept)</TableCell>
              <TableCell>Prospect (merged in)</TableCell>
              <TableCell>Score</TableCell>
              <TableCell>Signals</TableCell>
              <TableCell>Flagged</TableCell>
              <TableCell>Resolve</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dups.data?.map((d) => (
              <TableRow key={d.id}>
                <TableCell>
                  <Link component="button" onClick={() => set({ h: d.householdId }, false)}>
                    {d.householdName}
                  </Link>
                </TableCell>
                <TableCell>
                  <Link component="button" onClick={() => set({ h: d.candidateHouseholdId }, false)}>
                    {d.candidateHouseholdName}
                  </Link>
                </TableCell>
                <TableCell>
                  <DuplicateScore d={d} />
                </TableCell>
                <TableCell>
                  <DuplicateSignals d={d} />
                </TableCell>
                <TableCell>{d.createdAt.slice(0, 10)}</TableCell>
                <TableCell>
                  <DuplicateActions d={d} />
                </TableCell>
              </TableRow>
            ))}
            {dups.data?.length === 0 && (
              <TableRow>
                <TableCell colSpan={6}>No open possible duplicates.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
